import React from 'react';
import styles from './asset/scoreStatisticBoard.module.scss';
import ScoreSection from './components/ScoreSection';

// Main Component
const ScoreStatisticBoard = ({ accuracyData, isLoading = false }) => {
    if (isLoading) {
        return (
            <div className={styles.container}>
                <div className={styles.loadingSkeleton}>
                    <div className={styles.skeletonPulse} style={{ height: '24px', width: '60%', marginBottom: '20px' }} />
                    <div className={styles.skeletonContent}>
                        <div className={styles.skeletonPulse} style={{ height: '100px', width: '100%', marginBottom: '15px' }} />
                        <div className={styles.skeletonPulse} style={{ height: '100px', width: '100%' }} />
                    </div>
                </div>
            </div>
        );
    }

    const rwData = accuracyData?.['Reading & Writing'] || { accuracy_s: '--', attempted_s: 0, needsMorePractice: true, practicesLeft: 0 };
    const mathData = accuracyData?.['Math'] || { accuracy_s: '--', attempted_s: 0, needsMorePractice: true, practicesLeft: 0 }; return (
        <div className={styles.container}>
            <ScoreSection
                title="Reading & Writing Accuracy"
                subtitle="Based on recent practice questions"
                currentScore={rwData.accuracy_s}
                maxScore={100}
                attempted_s={rwData.attempted_s}
                needsMorePractice={rwData.needsMorePractice}
                practicesLeft={rwData.practicesLeft}
                isFirst={true}
            />
            <ScoreSection
                title="Math Accuracy"
                subtitle="Based on recent practice questions"
                currentScore={mathData.accuracy_s}
                maxScore={100}
                attempted_s={mathData.attempted_s}
                needsMorePractice={mathData.needsMorePractice}
                practicesLeft={mathData.practicesLeft}
                isFirst={false}
            />
        </div>
    );
};

export default ScoreStatisticBoard;